import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {urlJoin} from '../../../utils/urlJoin';
import {environment} from '../../../../environments/environment';
import {SearchObject} from 'src/app/domain/search/SearchObject';


@Injectable()
export class NewsService {

    constructor(private http: HttpClient) {
    }

    static get base() {
        return urlJoin(environment.server.hostSource, 'portail');
    }
    
    static get baseHaicop() {
        return urlJoin(environment.server.hostSource, 'haicop');
    }


    static get ged() {
        return urlJoin(environment.server.hostSource, 'ged');
    }


    loadData(options) {
        const resource = urlJoin(NewsService.base, 'ptNews', 'data');

        return this.http.post(resource, options);

    }

    loadDataAdmin(options) {
        const resource = urlJoin(NewsService.base, 'ptNoticeOpt', 'v_data');

        return this.http.post(resource, options);

    }

    loadDataBuyer(options) {
        const resource = urlJoin(NewsService.base, 'ptNoticeInst', 'v_data');

        return this.http.post(resource, options);

    }


    loadFiles(searchObject: SearchObject) {
        const resource = urlJoin(NewsService.ged, 'ptFile', 'data');

        return this.http.post(resource, searchObject);

    }

    loadcard(id) {
        const resource = urlJoin(NewsService.base, 'ptNews', id);
        return this.http.get(resource);


    }

    loadimage() {
        const resource = urlJoin(NewsService.base, 'ptNews', 'image');
        return this.http.get(resource);


    }

    loadcardAdmin(id) {
        const resource = urlJoin(NewsService.base, 'ptNoticeOpt/view', id);
        return this.http.get(resource);
    }

    updateHintCnt(id) {
        const resource = urlJoin(NewsService.base, 'ptNoticeOpt/updateHintCnt');
        return this.http.post(resource, {ptNoticeOptId: id});
    }

    updateHintCntHaicop(id) {
        const resource = urlJoin(NewsService.baseHaicop, '/vPtNoticeOpt/updateHintCnt');
        return this.http.post(resource, {ptNoticeOptId: id});
    }

    loadcardBuyer(id) {
        const resource = urlJoin(NewsService.base, 'ptNoticeInst/view', id);
        return this.http.get(resource);


    }


    download(noderef: string, name: string) {

        const resource = urlJoin(NewsService.ged, 'document', 'downloadFile?noderef=' + noderef);
        this.http.get(resource, {responseType: 'blob'}).subscribe(x => {
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            var newBlob = new Blob([x], {type: 'application/pdf'});

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob


            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);

            var link = document.createElement('a');
            link.href = data;
            link.download = name;
            // this is necessary as link.click() does not work on the latest firefox
            link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));

            setTimeout(function() {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
                link.remove();
            }, 100);
        });
    }


}
